const MAX_TITLE_LENGTH = 15;

export const trimText = (text: string): string => {
	return text.length > MAX_TITLE_LENGTH ? `${text.slice(0, MAX_TITLE_LENGTH)}...` : text;
};
